export class CONSTANTS {
    static readonly TRIP_STARTED: string = 'STARTED';
    static readonly TRIP_CREATED: string = 'CREATED';
    static readonly TRIP_CANCELLED: string = 'CANCELLED';
    static readonly TRIP_COMPLETED: string = 'COMPLETED';
    static readonly TRIP_ENDED: string = 'ENDED';

    static readonly PICKUP_TYPE_ADHOC = "ADHOC";
    static readonly PICKUP_TYPE_WORK = "WORK_PICKUP";
    static readonly PICKUP_TYPE_HOME = "HOME_PICKUP";
    static readonly PICKUP_TYPE_POINT_TO_POINT = "POINT_TO_POINT";
    static readonly  REVERSE_POINT_TO_POINT = 'REVERSE_POINT_TO_POINT';
    static readonly PICKUP_TYPE_DEFAULT = "WORK_PICKUP";
    static readonly ADHOC = 'ADHOC';


    static readonly DROPOFF_MANY = "MANY";
    static readonly DROPOFF_ONE = "ONE";

    static readonly ADMIN_TYPE_CLIENT = "CLIENT_ADMIN";
    static readonly ADMIN_TYPE_SUPER  = "SUPER_USER";
    static readonly ADMIN_TYPE_PROVIDER = "PROVIDER_ADMIN";
    static readonly ROLE_TYPE_DISPATCHER = "DISPATCHER";
    static readonly ROLE_TYPE_CUSTOMER_CARE = "CUSTOMER_CARE";
}


// WEBPACK FOOTER //
// ./src/app/utilities/Constants.ts